import React, { Component, PropTypes } from 'react'

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export function getTime(timeString, twentyFour) {
  const time = new Date(timeString)

  if (twentyFour)
    return `${time.getHours()}:${('0' + time.getMinutes()).slice(-2)}`

  const minutes = ('0' + time.getMinutes()).slice(-2)

  let hour = time.getHours()
  if (hour % 12 === 0 || hour === 0)
    hour = 12
  else
    hour = hour % 12
  return `${hour}:${minutes} ${time.getHours() / 12 > 1 ? 'PM' : 'AM'}`
}

export function getDateString(d, shorten = true) {
  const date = new Date(d)
  return `${getMonthString(date.getMonth(), shorten)} ${date.getDate()}, ${date.getFullYear()}`
}

export function getDateSentString(d, shorten = false) {
  const date = new Date(d)
  const currentDate = new Date()

  if (isSameDay(date, currentDate)) {
    return 'today'
  } else if (timeSince(date) === 'yesterday') {
    return 'yesterday'
  } else if (date.getFullYear() === currentDate.getFullYear()) {
    return `${getMonthString(date.getMonth(), shorten)} ${date.getDate()}`
  }

  return getDateString(date)
}

export function getMonthString(month, shorten) {
  let s = months[month];
  if (shorten && s.length > 4)
    return s.slice(0, 3)
  return s
}

export function isSameDay(d1, d2) {
  if (!d1 || !d2) return false

  const day1 = new Date(d1)
  const day2 = new Date(d2)

  return day1.getFullYear() === day2.getFullYear() &&
    day1.getMonth() === day2.getMonth() &&
    day1.getDate() === day2.getDate()
}

export function timeSince(date) {
  if (!date)
    return null

  const minute = 60000
  const hour = 60 * minute
  const day = 24 * hour

  const a = new Date()
  const b = new Date(date)

  let c = a - b

  if (c > day) {
    c = Math.floor( c / day )
    return (c > 1 ? c + ' days ago' : 'yesterday')
  }
  if (c > hour) {
    c = Math.floor( c / hour )
    return '' + c + (c > 1 ? ' hours' : ' hour') + ' ago'
  }
  if (c > minute) {
    c = Math.floor( c / minute )
    return '' + c + (c > 1 ? ' minutes' : ' minute') + ' ago'
  }
  return 'just now'
}

export class Time extends Component {
  constructor(props) {
    super(props)

    if (this.props.format === 'time-since') {
      const interval = setInterval(this.forceUpdate.bind(this), 60000)
      this.state = { interval }
    } else { this.state = {} }
  }

  static propTypes = {
    time: PropTypes.string.isRequired,
    twentyFour: PropTypes.bool,
    truncate: PropTypes.bool,
    format: PropTypes.oneOf([ 'time', 'date', 'time-date', 'date-time', 'time-since' ])
  }

  defaultProps = { truncate: true }

  componentWillUnmount() {
    if (this.state.interval) clearInterval(this.state.interval)
  }

  render() {
    const { time, format, truncate, twentyFour } = this.props
    return (
      <span className='time'>
        { format === 'time' ?
          getTime(time, twentyFour) :
            format === 'date' ?
            getDateString(time, truncate) :
              format === 'date-time' ?
              getDateString(time, truncate) + ' ' + getTime(time, twentyFour) :
                format === 'time-date' ?
                getTime(time, twentyFour) + ' ' + getDateString(time, truncate) :
                  format === 'time-since' ?
                  timeSince(time) :
                    format === 'time-sent' ?
                    'Sent ' + getDateSentString(time) + ' at ' + getTime(time, twentyFour) :
                      time
        }
      </span>
    )
  }
}
